module.exports = __webpack_public_path__ + "media/images/niq-flag-7ee0397dac3d3fdd170dfc0fd225050d.png";